import request from '@/utils/request'

// 查询工资详细
export function getSalaryDetailed(nickName, month) {
  return request({
    url: '/fina/salary/' + nickName + '/' + month,
    method: 'get',
    options: {
      loading: true
    }
  })
}
// 我所有的工资条
export function mySalaryList(nickName) {
  return request({
    url: '/fina/salary/mySalaryList/' + nickName,
    method: 'get',
    options: {
      loading: true
    }
  })
}
// 工资条确认/反馈情况
export function mySalarySelection(query) {
  return request({
    url: '/fina/callback/list',
    method: 'get',
    params: query
  })
}

// 确认/反馈
export function callback(data) {
  return request({
    url: '/fina/callback',
    method: 'post',
    data: data,
    options: {
      loading: true
    }
  })
}
// 反馈提醒
export function sendMessageCommon(data) {
  return request({
    url: '/fina/salary/sendMessageCommon/' + data.month + '/' + data.title + '/' + data.toUser + '/' + data.nickName + '/' + data.callbackId + '/' + data.remark + '/' + data.isCallback,
    method: 'get'
  })
}
// 反馈信息列表
export function callbackList(query) {
  return request({
    url: '/fina/callback/list',
    method: 'get',
    params: query
  })
}
// 反馈信息列表
export function callbackInfo(id) {
  return request({
    url: '/fina/callback/' + id,
    method: 'get'
  })
}

// 验证密码查看工资条
export function checkPassword(password) {
  return request({
    url: '/checkPassword?password=' + password,
    method: 'get'
  })
}
